import React from "react";
import { Outlet } from "react-router-dom";
import { usePageCustomisation } from "../../hooks/usePageCustomisation";
import { useCustomisation } from "../../context/CustomisationContext";
import { hasSomeCustomisation } from "../../utils/helpers";
import { GlobalLoader } from "../../components/GlobalLoader/GlobalLoader";

export const AuthRoute: React.FC = () => {
  const { customisations } = useCustomisation();
  usePageCustomisation("GPC");
  usePageCustomisation("LOGIN");

  const isReady =
    hasSomeCustomisation(customisations.customisations, "GPC") &&
    hasSomeCustomisation(customisations.customisations, "LOGIN");

  if (!isReady) return <GlobalLoader />;

  return <Outlet />;
};
